import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    padding: '1rem 0',
    margin: 0,
  },
  loading: {
    width: '100%',
    padding: 0,
  },
});

const PageSubtitle = ({text=null, isLoading=false}) => {
  const classes = useStyles();

  if (isLoading || text==null) {
    return (
      <div className={classes.loading}>
        <Skeleton animation="wave" height={40}/>
      </div>
    );
  }

  return (
    <Typography
      variant="h3"
      color="primary"
      className={classes.root}
    >
      {text}
    </Typography>
  );
};

PageSubtitle.propTypes = {
  text: PropTypes.node,
  isLoading: PropTypes.bool,
};

export default PageSubtitle;
